import { ApiClientError } from '@/shared/lib/api';
import { BaseApiService } from '@/shared/api/services/base.service';

export interface PromoCodeValidationRequest {
  code: string;
}

export interface PromoDiscount {
  type: 'percentage' | 'fixed';
  amount: string;
  description?: string;
}

export interface PromoCodeValidationResult {
  is_valid: boolean;
  message: string;
  discount?: PromoDiscount;
  discount_percentage?: number;
  discount_amount?: number;
}

export interface PromoCodeValidationResource {
  type: string;
  id: string | number;
  attributes: PromoCodeValidationResult;
}

export interface PromoCodeValidationResponse {
  data: PromoCodeValidationResource;
}

class PromoCodeService extends BaseApiService {
  async validatePromoCode(code: string): Promise<PromoCodeValidationResult> {
    try {
      const response = await this.post<PromoCodeValidationResponse>(
        '/v1/promo-codes/validate',
        this.formatJsonApiData('promo_code', { code })
      );

      const result = response.data.attributes;

      // discount_percentage / discount_amount mirror result.discount.amount
      // for legacy callers; remove once consumers migrate to result.discount.
      if (result.discount) {
        if (result.discount.type === 'percentage') {
          result.discount_percentage = parseFloat(result.discount.amount);
        } else if (result.discount.type === 'fixed') {
          result.discount_amount = parseFloat(result.discount.amount);
        }
      }

      return result;
    } catch (error) {
      if (error instanceof ApiClientError && error.isValidationError()) {
        return {
          is_valid: false,
          message: error.getFirstError(),
        };
      }
      throw error;
    }
  }
}

export const promoCodeService = new PromoCodeService();
